// Copyright (c) PikPok. All rights reserved
import {createRouter, createWebHistory} from "vue-router";
import * as views from './views/views'

const router =  createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'home',
      component: views.Home
    },
    {
      path: '/bug_report',
      name: 'contact',
      component: views.Home
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: views.Privacy
    },
    {
      path: '/privacyform',
      name: 'privacy-form',
      component: views.PrivacyFrom
    },
    {
      path: '/consentform',
      name: 'consent-form',
      component: views.ConsentForm
    },
    {
      path: '/technical_issue',
      name: 'technical-issue',
      component: views.TechnicalIssue
    },
    {
      path: '/account_and_data_help',
      name: 'account-and-data',
      component: views.AccountAndData
    },
    {
      path: '/billing_and_subscription',
      name: 'billing-and-subscription',
      component: views.BillingAndSubscription
    },
    {
      path: '/game_suggestion_and_feedback',
      name: 'game-suggestions-and-feedback',
      component: views.GameSuggestionsAndFeedback
    }
  ]
})

//Keeps query params between route changes
function hasQueryParams(route) {
  return !!Object.keys(route.query).length
}
router.beforeEach((to, from, next) => {
 if(!hasQueryParams(to) && hasQueryParams(from)){
    next({name: to.name, query: from.query});
  } else {
    next()
  }
})

export default router
